import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
export var NavSelectBlock = styled.div.withConfig({
  displayName: "NavSelect__NavSelectBlock",
  componentId: "sc-embvty-0"
})(["position:relative;margin:0 15px;color:", ";svg{position:absolute;top:24px;right:0;}", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.mainColor;
}, minMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: none;\n  "]))), maxMediaQueries.tablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: block;\n  "]))));
export var NavSelect = styled.select.withConfig({
  displayName: "NavSelect",
  componentId: "sc-embvty-1"
})(["position:relative;z-index:29;width:auto;padding:18px 21px 18px 0;cursor:pointer;font-family:", ";", ";font-weight:500;", " color:", ";::-ms-expand{display:none;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.bodyFontFamily;
}, getFont(0), fontSmoothing, function (_ref3) {
  var theme = _ref3.theme;
  return theme.mainColor;
});